/* PRANKWATERGLASSES — Premium micro-interactions */
(function(){
  if (window.__pwgInit) return; window.__pwgInit = true;

  const onReady = (fn) => (document.readyState !== 'loading')
    ? fn()
    : document.addEventListener('DOMContentLoaded', fn);

  onReady(function(){

    /* ===== Scroll reveal ===== */
    const revealEls = document.querySelectorAll('.pwg-reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(el => io.observe(el));
    } else {
      revealEls.forEach(el => el.classList.add('is-in'));
    }

    /* ===== Hero title word-by-word entrance ===== */
    document.querySelectorAll('.pwg-hero-title').forEach(t => {
      if (t.dataset.split) return;
      t.dataset.split = '1';
      const text = t.textContent.trim();
      t.innerHTML = text.split(' ').map(w => `<span class="word"><span>${w}</span></span>`).join(' ');
    });

    /* ===== Hero droplet generator ===== */
    document.querySelectorAll('.pwg-hero-droplets').forEach(host => {
      for (let i=0; i<14; i++){
        const d = document.createElement('span');
        d.className = 'pwg-droplet';
        const size = (4 + Math.random() * 9) | 0;
        d.style.width = size + 'px';
        d.style.height = size + 'px';
        d.style.left = (Math.random()*100) + '%';
        d.style.top = (Math.random()*30) + '%';
        d.style.animationDelay = (Math.random()*4) + 's';
        d.style.animationDuration = (3 + Math.random()*3) + 's';
        host.appendChild(d);
      }
    });

    /* ===== Sticky showcase frames (active frame syncs with scroll) ===== */
    const stickySteps = document.querySelectorAll('[data-pwg-step]');
    const frames = document.querySelectorAll('.pwg-sticky-frame');
    if (stickySteps.length && frames.length) {
      const setActive = (idx) => {
        frames.forEach((f, i) => f.classList.toggle('is-active', i === idx));
      };
      setActive(0);
      const stepIO = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const idx = parseInt(e.target.getAttribute('data-pwg-step'), 10) || 0;
            setActive(idx);
          }
        });
      }, { threshold: 0.5 });
      stickySteps.forEach(s => stepIO.observe(s));
    }

    /* ===== Mobile sticky buy bar ===== */
    const buy = document.querySelector('.pwg-mobile-buy');
    const hero = document.querySelector('.pwg-hero');
    if (buy && hero) {
      const heroIO = new IntersectionObserver(entries => {
        entries.forEach(e => buy.classList.toggle('is-visible', !e.isIntersecting));
      }, { threshold: 0.05 });
      heroIO.observe(hero);
    }

    /* ===== Subtle parallax for hero visual on desktop ===== */
    const heroVisual = document.querySelector('.pwg-hero-visual');
    if (heroVisual && matchMedia('(hover: hover)').matches){
      heroVisual.classList.add('tilt');
      heroVisual.addEventListener('mousemove', (e)=>{
        const r = heroVisual.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        heroVisual.style.transform = `perspective(1000px) rotateY(${x*4}deg) rotateX(${-y*4}deg)`;
      });
      heroVisual.addEventListener('mouseleave', ()=>{
        heroVisual.style.transform = '';
      });
    }

    /* ===== Magnetic cursor accent on desktop ===== */
    if (matchMedia('(hover: hover) and (pointer: fine)').matches){
      const dot = document.createElement('div');
      dot.className = 'pwg-cursor';
      document.body.appendChild(dot);
      let tx=0, ty=0, cx=0, cy=0;
      window.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; dot.classList.add('is-visible'); });
      const raf = () => {
        cx += (tx - cx) * .18; cy += (ty - cy) * .18;
        dot.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
        requestAnimationFrame(raf);
      };
      raf();
    }

    /* ===== Smooth in-page anchor scroll ===== */
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', (e)=>{
        const id = a.getAttribute('href');
        if (id.length > 1) {
          const t = document.querySelector(id);
          if (t) {
            e.preventDefault();
            t.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    /* ===== FAQ — exclusive open (optional polish) ===== */
    document.querySelectorAll('.pwg-faq-item').forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          document.querySelectorAll('.pwg-faq-item[open]').forEach(o => {
            if (o !== item) o.removeAttribute('open');
          });
        }
      });
    });

    /* ===== Marquee — duplicate track for seamless loop ===== */
    document.querySelectorAll('.pwg-marquee-track').forEach(t => {
      const c = t.cloneNode(true);
      c.setAttribute('aria-hidden','true');
      t.parentNode.appendChild(c);
    });

    /* ===== Bento hover tilt ===== */
    document.querySelectorAll('.pwg-bento-card').forEach(c => {
      c.addEventListener('mousemove', e => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        c.style.transform = `translateY(-4px) perspective(800px) rotateY(${x*2}deg) rotateX(${-y*2}deg)`;
      });
      c.addEventListener('mouseleave', () => c.style.transform = '');
    });

  });
})();
